import { isSprinkleProp } from '@/styles/is-sprinkle-prop'

import { Sprinkles } from '@/styles/sprinkles.css'

export function splitSprinkleProps<SourceProps>(source: any) {
  const props = {}
  const sprinkleProps = {}
  Object.entries(source).forEach(([key, value]) => {
    if (isSprinkleProp(key)) {
      (sprinkleProps as any)[key] = value
    } else {
      (props as any)[key] = value
    }
  })
  return [sprinkleProps, props] as [Sprinkles, Omit<SourceProps, keyof Sprinkles>]
}
